document.addEventListener('DOMContentLoaded', () => {
	const bis_form = document.querySelector('form.notify-form');
	if (bis_form) {
		bis_form.addEventListener('submit', (e) => {
			e.preventDefault();
			var myHeaders = new Headers();
			myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
			const email = bis_form.querySelector('input[type="email"]').value;
			const formMessage = document.querySelector('.pg-oos-banner-form .form-message');
			const klaviyoAPIKey = bis_form.getAttribute('data-klaviyo-api-key');
			const productID = bis_form.getAttribute('data-product-id');
			const successMessage = bis_form.getAttribute('data-form-success-message');
			const errorMessage = bis_form.getAttribute('data-form-error-message');
			var urlencoded = new URLSearchParams();
			urlencoded.append("a", klaviyoAPIKey);
			urlencoded.append("variant", productID);
			urlencoded.append("platform", "shopify");
			urlencoded.append("email", email);

			var requestOptions = {
					method: 'POST',
					headers: myHeaders,
					body: urlencoded,
					redirect: 'follow'
			};

			fetch("https://a.klaviyo.com/onsite/components/back-in-stock/subscribe", requestOptions)
				.then(response => response.text())
				.then(result => {
						// Handle the success message here
						formMessage.style.marginTop = "20px";
						formMessage.innerText = successMessage;
						formMessage.classList.remove('error');
						formMessage.classList.add('success');
						console.log(result);
				})
				.catch(error => {
						// Handle the error message here
						formMessage.style.marginTop = "20px";
						formMessage.innerText = errorMessage;
						formMessage.classList.remove('success');
						formMessage.classList.add('error');
						console.log('error', error);
				});
		});
	}
});